import { useRoute } from '@react-navigation/native';
import React from 'react';

import { STRINGS } from '@/constants/strings';
import InvitationSentContent from '@/features/guardian-player/components/invitation-sent';
import { useInvitationSent } from '@/features/guardian-player/hooks/use-invitation-sent';
import type { GuardianStackScreenProps } from '@/navigations/types';

const strings = STRINGS.guardianPlayer.invitationSent;

const InvitationSentScreen = () => {
  const route = useRoute<GuardianStackScreenProps<'InvitationSent'>['route']>();
  const { player, invitation } = route.params;

  const {
    firstName,
    status,
    expiresLabel,
    relationshipLabel,
    onBack,
    onBackToCircle,
    onRevoke,
    onResend,
    onRemove,
    onShareLink,
    isShareLoading,
  } = useInvitationSent(player, invitation);

  return (
    <InvitationSentContent
      screenTitle={strings.screenTitle}
      contact={invitation.contact}
      canJoinLabel={strings.canJoin.replace('{name}', firstName)}
      status={status}
      expiresLabel={expiresLabel}
      relationshipLabel={relationshipLabel}
      backLabel={strings.backToCircle.replace('{name}', firstName)}
      onBack={onBack}
      onBackToCircle={onBackToCircle}
      onRevoke={onRevoke}
      onShareLink={onShareLink}
      isShareLoading={isShareLoading}
      onResend={onResend}
      onRemove={onRemove}
    />
  );
};

export default InvitationSentScreen;
